import React from "react";
const engageAIContent = {
  overview: {
    title: "inFlow EngageAI",
    headline: "AI agents that elevate every business interaction",
    description:
      "inFlow EngageAI deploys conversational AI agents across voice, chat, and digital channels to automate customer support, sales inquiries, and appointment bookings — delivering 24/7 intelligent engagement.",
    imageURL: "/images/products/EngageAI-3D-Studio-Banner.png",
    screenURL: "/images/products/EngageAI-3D-Studio-Banner.png",
    buttons: [
      "Customer Support",
      "Credit card payment",
      "iNextLabs Voice Assistant",
    ],
  },
  demos: [
    {
      title: "Customer Support",
      tag: "text",
      path: "/demo/customer-support",
      image: "/images/products/EngageAI-CustomerSupport.png",
      description: [
        "Experience an AI assistant that handles L1 queries, raises tickets, shares status updates, and logs feature requests — all in one seamless flow.",
      ],
    },
    {
      title: "Credit Card Reminders",
      tag: "voice",
      path: "/demo/credit-card-reminder",
      image: "/images/products/EngageAI-CreditCardReminder.png",
      description: [
        "Explore how a voice agent makes outbound calls to remind users of upcoming dues, share payment summaries, and answers follow-up questions.",
      ],
    },
    {
      title: "Sales Assistant",
      tag: "voice",
      path: "/demo/sales-assistance",
      image: "/images/products/SalesAssistant.png",
      description: [
        "Experience a voice assistant that guides prospects through product offerings, answers solution-specific queries, and captures demo requests.",
      ],
    },
    {
      title: "Appointment Booking",
      tag: "voice",
      path: "/demo/appointment-booking",
      image: "/images/products/EngageAI-Appointment-Booking.png",
      description: [
        "Explore how a voice agent automates appointment bookings by confirming doctor availability, capturing patient details, and scheduling visits in seconds. ",
      ],
    },
    {
      title: "Avatar Bot",
      tag: "Avatar",
      path: "/demo/avatar-bot",
      image: "/images/products/EngageAI-AvatarBot.png",
      description: [
        "A general-purpose AI assistant that answers open-ended questions. Interact using text or voice and get instant responses in a human-like avatar format.",
      ],
    },
    {
      title: "Clinical Assistant",
      tag: "text",
      path: "/demo/clinical-assistant",
      image: "/images/products/clinical-assistant.png",
      description: [
        "Enables patients to explore services, ask questions, and manage appointments — including booking, rescheduling, and cancellations .",
      ],
    },
    {
      title: "Virtual Mall Concierge",
      tag: "Avatar",
      path: "/demo/virtual-mall-concierge",
      image: "/images/products/EngageAI-AvatarBot.png",
      description: [
        "AI-powered mall assistant providing instant support, product recommendations, and smooth shopping guidance.",
      ],
    },
    {
      title: "PSD Avatar",
      tag: "Avatar",
      path: "/demo/psd-avatar",
      image: "/images/products/EngageAI-AvatarBot.png",
      description: [
        "AI-powered avatar that simulates real customer conversations, helping support teams practice, improve responses, and build confidence through realistic interactions.",
      ],
    },
  ],
  pricing: {
    plans: [
      {
        id: "advantage",
        name: "ADVANTAGE",
        price: 399,
        period: "month",
        conversations: "2,000 conversations / month",
        popular: false,
        features: [
          { label: "Users", value: "10" },
          { label: "Live Agents", value: "4" },
          { label: "Broadcast Messages/month", value: "100,000" },
          { label: "Storage", value: "75 GB" },
          { label: "Agent Languages", value: "3" },
          { label: "Text", value: true },
          { label: "Image", value: true },
          { label: "Handwriting", value: true },
          { label: "Voice", value: true },
          { label: "Avatar", value: false },
          { label: "Web", value: true },
          { label: "WhatsApp", value: true },
          { label: "Social Media", value: true },
          { label: "Email Channel", value: true },
          { label: "Telephone Channel", value: false },
          { label: "User Feedback", value: true },
          { label: "Content from verified websites", value: true },
          { label: "Custom Prompt", value: true },
          { label: "Ask AI", value: true },
          { label: "Continuous Learning", value: true },
          { label: "Omni Channel Support", value: false },
          { label: "PII Masking", value: false },
          { label: "InFlow Copilot", value: false },
          { label: "InFlow Shield", value: false },
          { label: "Support", value: "Bot + Email + Phone" }
        ]
      },
      {
        id: "premium",
        name: "PREMIUM",
        price: 599,
        period: "month",
        conversations: "3,000 conversations / month",
        popular: true,
        features: [
          { label: "Users", value: "15" },
          { label: "Live Agents", value: "6" },
          { label: "Broadcast Messages/month", value: "200,000" },
          { label: "Storage", value: "100 GB" },
          { label: "Agent Languages", value: "5" },
          { label: "Text", value: true },
          { label: "Image", value: true },
          { label: "Handwriting", value: true },
          { label: "Voice", value: true },
          { label: "Avatar", value: false },
          { label: "Web", value: true },
          { label: "WhatsApp", value: true },
          { label: "Social Media", value: true },
          { label: "Email Channel", value: true },
          { label: "Telephone Channel", value: false },
          { label: "User Feedback", value: true },
          { label: "Content from verified websites", value: true },
          { label: "Custom Prompt", value: true },
          { label: "Ask AI", value: true },
          { label: "Continuous Learning", value: true },
          { label: "Omni Channel Support", value: true },
          { label: "PII Masking", value: true },
          { label: "InFlow Copilot", value: false },
          { label: "InFlow Shield", value: false },
          { label: "Support", value: "Bot + Email + Phone" }
        ]
      },
      {
        id: "ultimate",
        name: "ULTIMATE",
        price: 899,
        period: "month",
        conversations: "5,000 conversations / month",
        popular: false,
        features: [
          { label: "Users", value: "25" },
          { label: "Live Agents", value: "10" },
          { label: "Broadcast Messages/month", value: "unlimited" },
          { label: "Storage", value: "150 GB" },
          { label: "Agent Languages", value: "10" },
          { label: "Text", value: true },
          { label: "Image", value: true },
          { label: "Handwriting", value: true },
          { label: "Voice", value: true },
          { label: "Avatar", value: true },
          { label: "Web", value: true },
          { label: "WhatsApp", value: true },
          { label: "Social Media", value: true },
          { label: "Email Channel", value: true },
          { label: "Telephone Channel", value: true },
          { label: "User Feedback", value: true },
          { label: "Content from verified websites", value: true },
          { label: "Custom Prompt", value: true },
          { label: "Ask AI", value: true },
          { label: "Continuous Learning", value: true },
          { label: "Omni Channel Support", value: true },
          { label: "PII Masking", value: true },
          { label: "InFlow Copilot", value: true },
          { label: "InFlow Shield", value: true },
          { label: "Support", value: "Bot + Email + Phone" }
        ]
      }
    ],
  },
  usecase: [
    {
      industry: "Healthcare ",
      points: [
        "Handling appointment booking, rescheduling, and reminders through web and WhatsApp",
        "Assisting with patient inquiries related to doctors, departments, services, and insurance coverage ",
        "Collecting patient feedback post-visit to improve care quality and operational efficiency",
        "Running awareness campaigns and health promotion initiatives via automated outreach",
      ],
    },
    {
      industry: "Real Estate & Property Management ",
      points: [
        "Automate responses to rental/buying inquiries across listings ",
        "Schedule site visits or virtual tours via WhatsApp ",
        "Manage maintenance requests and tenant communication ",
        "Answer FAQs on lease terms, facilities, and documentation",
      ],
    },
    {
      industry: "Banking & Financial Services ",
      points: [
        "Automating responses to FAQs around account openings, loans, credit cards, and investments",
        "Collecting KYC documents and scheduling branch appointments via secure conversational flows",
        "Enabling product recommendation journeys based on user intent and eligibility",
        "Managing grievance redressal with AI triage and smart escalation to relationship managers ",
      ],
    },
    {
      industry: "Retail & eCommerce ",
      points: [
        "Assisting users with product discovery, availability, and pricing queries ",
        "Guiding customers through order placement, returns, cancellations, and refund status",
        "Providing multilingual chatbot support during high-traffic events and seasonal sales ",
        "Promoting offers and new arrivals with personalized engagement campaigns",
      ],
    },
    {
      industry: "Travel, Transport & Hospitality",
      points: [
        "Handling inquiries related to bookings, cancellations, ticket changes, and travel advisories",
        "Assisting customers with loyalty programs, special offers, and local recommendations ",
        "Collecting guest feedback and satisfaction surveys after stay or travel experiences ",
        "Automating internal requests like housekeeping, room service, or airport pickup coordination",
      ],
    },
    {
      industry: "Workplace Automation (HR, IT, Admin) ",
      points: [
        "Answering employee queries on leave policy, benefits, payroll, or onboarding ",
        "Logging and triaging IT tickets related to hardware, software, or access requests",
        "Assisting with booking, scheduling, and admin requests ",
        "Supporting hybrid workforce needs through voice and chat-based virtual assistants ",
      ],
    },
  ],
  customerstory: {
    stories: [
      {
        tag: "SIGNAGE & PRODUCT IDENTIFICATION · SINGAPORE",
        client: "Million Advertising",
        stat: "24/7 ERP Sync",
        image: "/images/case-studies/million-advertising.jpg",
        title: "Million Advertising: Bringing AI-Powered Customer Engagement to Signage Manufacturing",
        text: "Million Advertising partnered with iNextLabs to deploy EngageAI, securely connecting conversational AI with an on-premise ERP to deliver real-time order tracking 24/7.",
        url: "https://inextlabs.ai/resources/million-advertising-ai-customer-service-on-premise-erp",
        outcomes: [
          "24/7 automated order status tracking directly integrated with on-premise ERP",
          "Secure bridge behind corporate firewall without moving sensitive data to the cloud",
          "Award-winning enterprise AI deployment slashing customer support workload"
        ]
      },
      {
        tag: "FIELD SERVICES & MAINTENANCE · SINGAPORE",
        client: "Leading Services Company",
        stat: "Closed-Loop AI",
        image: "/images/case-studies/agentic-ai-workforce.jpg",
        title: "An Agentic AI Workforce That Turns Service Data Into the Next Customer Opportunity",
        text: "A leading Singapore services firm deployed the iNextLabs AI Workforce — InsightsAI, EngageAI, and DocsAI — turning service history and handwritten field reports into a closed-loop customer re-engagement engine.",
        url: "https://inextlabs.ai/resources/agentic-ai-workforce-service-data-customer-opportunity",
        outcomes: [
          "Autonomous closed-loop lifecycle: InsightsAI identifies service opportunities, EngageAI triggers outreach, DocsAI digitizes field reports",
          "Handwritten field service reports captured via WhatsApp and transformed into structured CRM data with zero manual entry",
          "Proactive customer re-engagement driven by AI analysis of equipment service validity cycles"
        ]
      },
      {
        tag: "FOOD & BEVERAGE · MALAYSIA",
        client: "Leading Malaysian Tea Brand (800+ Outlets)",
        stat: "800+ Outlets",
        image: "/images/resources/case-study/222510.webp",
        title: "How a Leading Malaysian Tea Brand Scaled Customer Communication Across 800 Outlets",
        text: "Rapid growth caused communication breakdowns, missed orders, and long wait times during peak hours. iNextLabs EngageAI enabled real-time multilingual customer support on WhatsApp, reducing missed orders and improving customer satisfaction across 800+ outlets.",
        url: "https://inextlabs.ai/resources/malaysia-tea-brand-800-outlets-engageai",
        outcomes: [
          "Multilingual AI ordering and support across 800+ franchise locations",
          "Elimination of missed orders during afternoon rush hours",
          "Seamless integration with point-of-sale and kitchen display systems"
        ]
      },
      {
        tag: "HEALTHCARE · MALAYSIA",
        client: "Leading Eye Care Provider in Malaysia",
        stat: "24/7 Triage",
        image: "/images/resources/case-study/eyecare-malaysia.png",
        title: "How a Leading Eye Care Provider in Malaysia Transformed Patient Support",
        text: "A multi-branch eye specialist clinic in Malaysia faced slow patient response times across social channels and WhatsApp. iNextLabs EngageAI delivered 24/7 omnichannel automated patient enquiry handling, appointment management, and Meta Ads auto-replies.",
        url: "https://inextlabs.ai/resources/malaysia-eyecare-patient-support-engageai",
        outcomes: [
          "24/7 automated patient triage and doctor schedule lookup",
          "Automated follow-up reminders cutting no-shows by 32%",
          "Direct auto-reply pipeline for Meta Ads patient leads"
        ]
      },
      {
        tag: "BUILDING MATERIALS · INDIA",
        client: "Leading Ceramic Tile Distributor (16 Branches)",
        stat: "70% Auto-Resolved",
        image: "/images/resources/case-study/customer-management-experience-meeting-concept.webp",
        title: "How a Leading Ceramic Tile Distributor in Tamil Nadu Improved Customer Engagement Across 16 Branches",
        text: "Manual inquiry handling, no after-hours support, and no social channel coverage. iNextLabs EngageAI resolved 70% of FAQs automatically, increased leads from Google by 20%, and eliminated missed inquiries across 16 branches.",
        url: "https://inextlabs.ai/resources/tamil-nadu-ceramic-tile-distributor-engageai",
        outcomes: [
          "70% automated FAQ resolution across 23 tile brands",
          "20% surge in qualified inbound leads from Google Business Messages",
          "Unified agent portal tracking past conversation history for 16 branches"
        ]
      },
    ],
  },
  resources: {
    diagrams: [
      {
        name: "EngageAI for Customer Service",
        type: "video",
        tag: "VIDEO",
        image: "EngageAI-for-Customer Service.mp4",
        duration: "12 min",
        size: "Video · 31.8 MB",
        desc: "Watch how EngageAI helps teams resolve queries faster and deliver exceptional support.",
        isHero: true,
      },
      {
        name: "EngageAI for Smart Ordering",
        type: "video",
        tag: "VIDEO",
        image: "EngageAI-for-smart-ordering.mp4",
        duration: "8 min",
        size: "Video · 15.8 MB",
        desc: "See how AI agents automate ordering and streamline the entire intake process.",
      },
      {
        name: "EngageAI for Sales Intelligence",
        type: "video",
        tag: "VIDEO",
        image: "EngageAI-Sales-Intelligence.mp4",
        duration: "10 min",
        size: "Video · 48.9 MB",
        desc: "Discover real-time lead qualification and conversational sales intelligence.",
      },
      {
        name: "InFlow EngageAI Solution Flyer V3.0",
        type: "pdf",
        tag: "PDF",
        image: "brochure/InFlow EngageAI Flyer V3.0.pdf",
        size: "PDF · 973 KB",
        desc: "Comprehensive enterprise feature matrix, channel adapters, and security architecture.",
      },
      {
        name: "Customer Service Brochure V3.0",
        type: "pdf",
        tag: "PDF",
        image: "brochure/Customer Service V3.0.pdf",
        size: "PDF · 1.7 MB",
        desc: "Detailed overview of customer service AI capabilities, multi-lingual voice bots, and automated ticketing.",
      },
      {
        name: "Sales Intelligence Brochure V3.0",
        type: "pdf",
        tag: "PDF",
        image: "brochure/Sales Intelligence V3.0.pdf",
        size: "PDF · 1.2 MB",
        desc: "Discover conversational lead qualification, CRM integration, and real-time sales intelligence.",
      },
      {
        name: "Smart Ordering Brochure V3.0",
        type: "pdf",
        tag: "PDF",
        image: "brochure/Smart Ordering V3.0.pdf",
        size: "PDF · 840 KB",
        desc: "Automated ordering workflow, menu sync, and multi-channel conversational commerce.",
      },
      {
        name: "EngageAI Voice Agent Flyer",
        type: "pdf",
        tag: "PDF",
        image: "brochure/EngageAl Voice Agent New Flyer.pdf",
        size: "PDF · 582 KB",
        desc: "Ultra-low latency conversational voice agents with emotion detection and telephony integration.",
      },
      {
        name: "Clinical Assistance Solution Flyer",
        type: "pdf",
        tag: "PDF",
        image: "brochure/EngageAl for Clinical Assistance New Flyer.pdf",
        size: "PDF · 541 KB",
        desc: "HIPAA-compliant healthcare assistant for patient triage, appointment bookings, and EHR sync.",
      },
      {
        name: "Retail & Commerce AI Flyer",
        type: "pdf",
        tag: "PDF",
        image: "brochure/EngageAl for Retail New Flyer.pdf",
        size: "PDF · 464 KB",
        desc: "Personalized product discovery, omnichannel promotions, and automated order fulfillment.",
      },
      {
        name: "Agentic AI Customer Service Whitepaper",
        type: "pdf",
        tag: "PDF",
        image: "whitepapers/agentic-ai-customer-service.pdf",
        size: "PDF · 604 KB",
        desc: "Technical whitepaper on autonomous multi-agent reasoning and human-in-the-loop workflows.",
      },
      {
        name: "AI Smart Ordering Playbook",
        type: "pdf",
        tag: "PDF",
        image: "whitepapers/ai-powered-smart-ordering-restaurants.pdf",
        size: "PDF · 876 KB",
        desc: "Industry playbook on reducing wait times and scaling digital ordering across F&B chains.",
      },
      {
        name: "iNextLabs Corporate Overview Flyer V4",
        type: "pdf",
        tag: "PDF",
        image: "brochure/_iNextLabs Corporate Flyer V4_compressed.pdf",
        size: "PDF · 2.0 MB",
        desc: "Complete company overview, enterprise AI platform capabilities, and partner ecosystem.",
      },
      {
        name: "Voice Bot Architecture",
        type: "diagram",
        tag: "DIAGRAM",
        image: "architecture/STS Arch Diagram.png",
        size: "PNG · 277 KB",
        desc: "High-resolution architectural diagram of multi-modal voice processing topology.",
      },
      {
        name: "EngageAI Commercial Proposal",
        type: "doc",
        tag: "DOC",
        image: "documents/inFlowEngageAI-proposal.docx",
        size: "DOCX · 6.2 MB",
        desc: "Explore complete system architecture, commercial terms, and rollout roadmap.",
      },
      {
        name: "Customer Support Proposal",
        type: "doc",
        tag: "DOC",
        image: "documents/inFlowEngageAI-proposal.docx",
        size: "DOCX · 1.4 MB",
        desc: "Tailored enterprise SLA support specifications and multi-channel coverage.",
      },
    ],
  },
};

export default engageAIContent;
